module.exports = __webpack_public_path__ + "img/blog.4dfa259e.jpg";